export const preventMinus = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.code === 'Minus') {
    event.preventDefault();
  }
};
